var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.93096 14.75L7.50009 10.75M8.93096 14.75L7.83847 15.0081M8.93096 14.75H10.0001M7.50009 10.75L3.85686 12.086C3.60665 12.1777 3.47238 12.4496 3.55161 12.7041L4.36332 15.3108C4.44063 15.559 4.69533 15.7066 4.94917 15.6502L7.83847 15.0081M7.50009 10.75L12.3913 7.32616C12.4626 7.27625 12.5196 7.2086 12.5568 7.1299L13.0678 6.04668M13.0678 6.04668L14.5199 5.44799C14.7821 5.33988 15.0816 5.47127 15.1797 5.73739L18.317 14.2531C18.4164 14.5228 18.2685 14.8205 17.9935 14.9043L16.5521 15.3433M13.0678 6.04668L16.5521 15.3433M16.5521 15.3433L15.2755 14.7911C15.2129 14.764 15.1453 14.75 15.077 14.75H10.0001M7.83847 15.0081L8.41822 18.287C8.46423 18.5472 8.70474 18.7266 8.96726 18.6967L10.1647 18.5601C10.4528 18.5272 10.6526 18.2569 10.5996 17.9718L10.0001 14.75M19.5001 11.75V11.75C20.1009 9.94747 19.5144 7.96148 18.0308 6.77454L18.0001 6.75",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon);
export default __webpack_public_path__ + "static/media/SocialIcon.4f2052f0d06344e75331b91e9d7a375e.svg";
export { ForwardRef as ReactComponent };